export default __webpack_public_path__ + "static/media/sc3.7f50cd9b.png";